
export default {
    name: 'b-navbar-brand',
};
